'use client'

import { useMemo } from 'react'
import { Icon } from '../Icon'
import { useDialogStore } from '../dialog/FullScreenBackDrop'
import { useSearchParams } from 'next/navigation'
import { SelectedFilters } from './ChartFilterSheet'
import { WithT } from '@/locales/types'
import { createT } from '@/locales/index'

type Props = {
  id: string
}

export const ComplexFilter = ({ id, translations }: WithT<Props>) => {
  const t = createT(translations)
  const dialog = useDialogStore()
  const searchParams = useSearchParams()
  const selectedFilters = useMemo(() => {
    return JSON.parse(searchParams.get(id) || '{}') as SelectedFilters
  }, [id, searchParams])

  const selectedFilterLength = useMemo(() => {
    const copy = JSON.parse(JSON.stringify(selectedFilters))
    delete copy.date
    delete copy.order
    delete copy['date-val']
    delete copy.key

    return Object.values(copy).flat().length
  }, [selectedFilters])

  const onClickButton = () => {
    dialog.push(id)
  }

  return (
    <div className="relative z-10">
      <div className="flex gap-3">
        <button
          className="border-gray-400 rounded-lg px-3 py-2 border flex gap-1 items-center"
          onClick={onClickButton}
        >
          <span className="text-body2 font-medium leading-tight">
            {t('filter')}
          </span>
          {selectedFilterLength > 0 && (
            <span className="text-key text-body2 font-medium">
              {selectedFilterLength}
            </span>
          )}
          <Icon name="filter" size={14} />
        </button>
      </div>
    </div>
  )
}
